module.exports = __webpack_public_path__ + "static/img/Long.2d310f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Long.jpg
// module id = QhAf
// module chunks = 0